export default {
    getFromLocalStorageByKey(key, jsonParse = true ) {
        let field = null;
        console.error("get from storage service");

        if(jsonParse && localStorage.getItem(key) !== null) {
            field = JSON.parse(localStorage.getItem(key));
        }
        if(!jsonParse && localStorage.getItem(key) !== null) {
            field = localStorage.getItem(key);
        }
        if (localStorage.getItem(key) === null) {
            field = false;
        }

        return field
    },
    setToLocalStorageByKey(key = 'fullStorageProductList', value) {
        console.warn("!!!Storage service before set: " + key);
        console.log(this.getFromLocalStorageByKey(key));
        console.log(value);

        localStorage.setItem(key, JSON.stringify(value));

        console.warn("!!!Storage service after set");
        console.log(this.getFromLocalStorageByKey(key));
    },
    addToLocalStorageProductID(prID,addToLocalStorageByKey = "fullStorageProductList") {
        let stringProductList = '';
        let separator = '_';

        stringProductList = this.getFromLocalStorageByKey('stringProductList', false);

        if(stringProductList)  {
            stringProductList = localStorage.getItem("stringProductList");
            stringProductList += separator + prID;
        } else {
            stringProductList += prID;
        }

        
        localStorage.setItem(addToLocalStorageByKey, stringProductList);
        //localStorage.setItem("stringProductList", stringProductList);
    },

    removeFromLocalStorageProductID(prID) {
        let stringProductList = this.getFromLocalStorageByKey("stringProductList", false);
        let separator = '_';
        let productListIdsArr = [];

        if(stringProductList)  {
            localStorage.removeItem("stringProductList");
            // eslint-disable-next-line
            if(!!~stringProductList.indexOf(separator)) {
                productListIdsArr = stringProductList.split(separator);
                productListIdsArr.forEach(
                    (id, index) => {
                        if(id == prID) {
                            productListIdsArr.splice(index, 1);
                        }
                    }
                );
            }
            stringProductList = productListIdsArr.join(separator);
        }

        localStorage.setItem("stringProductList", stringProductList);
    },

    addToLocalStorageByKey(key, value, stringify = true) {

        // TODO can be improved with checking if current key is free
        if(key && value) {
            if(stringify) {
                value = JSON.stringify(value);
            }

            localStorage.setItem(key, value);
        }
    }
}